import { Avatar } from "@mui/material";
import config from "../../../../utils/config/config";
import SubIconComponent from "./SubIconComponent";
import { memo } from "react";

const SideSubMenu = ({
  botSubscriptions,
  isExpanded,
  item,
  activeItem,
  handleSubItemClick,
  isMobile,
  isSideBar,
  acceptedContacts,
  allProfileImages,
  selectedBotDetails
}) => {

  const setProfileImg = (contact, userId, allProfileImages) => {
    if (contact.contactType === "local") {
      if (allProfileImages) {
        return allProfileImages[userId + contact.userId];
      }
    } else {
      if (allProfileImages) {
        return allProfileImages[contact.userId];
      }
    }
  };

  return (
    <>
      {botSubscriptions &&
        isExpanded &&
        (
          <ul className={`space-y-2 my-3 ${!isMobile && !isSideBar ? "ms-7" : "ms-3"}`} >
            {botSubscriptions
              .sort((a, b) => a.botName.localeCompare(b.botName))
              .map((subItem, subIndex) => {

                const isSubActive = activeItem === `${item.name}-${subItem.botName}`;

                return (
                  <li key={subIndex}>
                    <button
                      onClick={() => {
                        if (selectedBotDetails?.botId === subItem?.botId) {
                          return
                        } else {
                          handleSubItemClick(subItem.botName, item.name, subItem)
                        }
                      }}
                      className={`w-full flex items-center space-x-2 text-left transition-colors duration-200 p-[3px] rounded-7 text-size-12 ${isSubActive
                        ? "bg-white text-primary-blue"
                        : "hover:text-purple-100"
                        }`}
                    >
                      <SubIconComponent subItem={subItem} config={config} />
                      {!isMobile && !isSideBar && (
                        <span className="">{subItem.botName}</span>
                      )}
                    </button>
                  </li>
                );
              })}

            {/* <div
          className="flex items-center space-x-2 text-cyan-400 cursor-pointer hover:underline px-1 ms-1"
        >
          <span className="text-base">+</span>
          {!isMobile && !isSideBar && <span>Add apps</span>}
        </div> */}
          </ul>
        )}
      {acceptedContacts && isExpanded && item.name === "Contacts" && (
        acceptedContacts.map((subItem, subIndex) => {
          const isSubActive = activeItem === `${item.name}-${subItem.userId}`;
          const imgSrc = setProfileImg(acceptedContacts, subItem.userId, allProfileImages);
          const name = subItem.name || subItem.userName || "";
          const initial = name.charAt(0).toUpperCase();

          return (
            <div
              key={subItem.userId || subIndex}
              className={`flex items-center space-x-2 my-2 ${!isMobile && !isSideBar ? "ms-10" : "ms-3"}`}
            >
              <div style={{ marginRight: "10px" }}>
                {imgSrc ? (
                  <Avatar
                    style={{
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                    }}
                    name={name}
                    size={6}
                    height={6}
                    color="bg-info"
                    imgSrc={imgSrc}
                  />
                ) : (
                  <div className="flex items-center justify-center w-8 h-8 rounded-full bg-sky-400 text-white text-size-13 font-semibold" >
                    {initial}
                  </div>
                )}
              </div>
              <span className={`${isSubActive ? "font-semibold text-primary" : ""}`}>
                {subItem.userName}
              </span>
            </div>
          );
        })
      )}
    </>
  )
};

export default memo(SideSubMenu)